<script src="../api/index.js"></script>
<template>
  <div >
    <el-row style="padding-bottom: 15px">
      <el-col :span="12">
        <el-col :span="22"><img style="width: 100%" src="../assets/cc71f4f46693998aad5db0a53cc8da7.png" alt="青岛证券协会logo"/></el-col>
      </el-col>
      <el-col :span="4" :offset="1">
        <div style="margin-top: 45px; font-size: 25px;"><span>（试运行）</span></div>
      </el-col>
      <el-col :span="4" :offset="1">
        <el-input
            style="margin-top: 25px"
            placeholder="请输入内容"
            v-model="search">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchSomething"></i>
        </el-input>
      </el-col>
    </el-row>
    <el-row style="background-color:white !important;">
      <el-col :offset="1" :span="20">
        <el-menu
            router
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            background-color="white"
            text-color="black"
            active-text-color="#154480"
        >
          <el-menu-item class="shouye" index="/index">首页</el-menu-item>
          <el-submenu index="/other/1">
            <template slot="title">关于协会</template>
            <el-menu-item index="/showArt/8">协会简介</el-menu-item>
            <el-menu-item index="/showArt/10">协会章程</el-menu-item>
            <el-menu-item index="/showArt/11">组织架构</el-menu-item>
            <el-menu-item index="/other/17">会员大会</el-menu-item>
            <el-menu-item index="/showArt/12">联系我们</el-menu-item>
          </el-submenu>
          <el-submenu index="/other/3">
            <template slot="title">监管动态</template>
            <el-menu-item index="/other/22">监管动态</el-menu-item>
            <el-menu-item index="/other/23">警示台</el-menu-item>
          </el-submenu>
          <el-submenu index="/other/2">
            <template slot="title">协会动态</template>
            <el-menu-item index="/other/18">通知公告</el-menu-item>
            <el-menu-item index="/other/19">协会动态</el-menu-item>
            <el-menu-item index="/other/20">自律管理</el-menu-item>
            <el-menu-item index="/other/21">活动相册</el-menu-item>
          </el-submenu>


          <el-submenu index="/other/4">
            <template slot="title">会员园地</template>
            <el-menu-item index="/other/27">行业文化建设</el-menu-item>
            <el-menu-item index="/other/10">会员动态</el-menu-item>
            <el-menu-item index="/other/11">会员呼声</el-menu-item>
            <el-menu-item index="/other/24">招聘信息</el-menu-item>
          </el-submenu>
          <el-submenu index="/other/">
            <template slot="title">投资者教育</template>
            <el-menu-item index="/other/12">投教动态</el-menu-item>
            <el-menu-item index="/other/25">百日讲坛</el-menu-item>
            <el-menu-item index="/other/13">风险提示</el-menu-item>
            <el-menu-item index="/other/14">投资者之家</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
      <el-col :span="2" >
        <h3 style="color: #154480;position: relative;bottom: -15px;cursor: pointer;"><a class="aaa" target="_blank" href="http://117.78.21.84:8088"><i
            class="el-icon-user"></i>用户登录</a>
        </h3>
      </el-col>
    </el-row>
    <div style="border-bottom:10px solid #154480;width: 100%;position: relative;bottom: 10px"></div>
<div style="position: relative;left: 410px">
<!--       <Breadcrumb v-if="$route.path!=='/index'"></Breadcrumb>-->

</div>

    <router-view/>
    <div class="footer">
      <div class="fffffoot">
        <div class="inline">
          <p style="; padding-top:27px ">本站已被访问{{ this.count }}人次</p>
          <p>CopyRight©2022 SFAQ All Rights Reserved</p>
          <p>青岛证券期货业协会版权所有</p>
        </div>
        <div class="inline" style="padding-left: 150px">
          <p style="padding-top:27px "><i class="el-icon-phone"> 0532-66062126</i></p>

          <p>
            <a style="color: #ffffff;" target="_blank" href="https://beian.miit.gov.cn">
              <a-icon type="safety-certificate"/>
              鲁ICP备12029878号
            </a>
          </p>
          <p><i class="el-icon-location-outline"> 青岛市东海西路28号龙翔广场1号楼</i></p>
        </div>
        <div class="iii " >
<!--        <div style="position:relative; bottom: 1px">-->
          <img class="qrcode" src="../assets/sssss.jpg" alt=""/>
          <span class="footer-fout-size-right">青岛资本市场</span>
        </div>
        <div class="iii " >
<!--        <div >-->
          <img class="qrcode" src="../assets/0e3d0fccd8c6f5de1e734243eb3e0c8.jpg" alt=""/>
          <span class="footer-fout-size-left">青岛证券期货业协会</span>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {visitNumber, marList} from '../api/index'

export default {
  name: 'homepage',
  data() {
    return {
      //search on the top
      search: '',
      activeIndex: '1',
      count: 0,
      marqueeList: null,

    }
  },
  created() {

    marList().then(res => {
      this.marqueeList = res.data.data.rows;
    })
    visitNumber().then(res => {
      this.count = res.data.data
    })
  },
  methods: {

    getMarquee(row) {
      if (row.articleId !== null) {
        this.$router.push(`/articles/${row.id}`)
      }
    },
    // button on the top
    searchSomething() {
      if (this.$route.meta.title === '搜索结果') {
        window.sessionStorage.setItem("value", this.search)
        location.reload();
      } else {
        if (this.search !== '' && this.search !== null && this.search !== undefined) {
          window.sessionStorage.setItem("value", this.search)
          this.$router.push('/searchPage')
        } else {
          alert('请输入搜索内容')
        }
      }


    },
  }
}
</script>

<style scoped lang="scss">
.footer {
  height: 150px;
  background-color: #154480;
  color: white;

}

.fffffoot {
  width: 1300px;
  margin: 0 auto;
  height: 100%;
  .inline{
    display: inline;
    float:left;
    padding-right: 10px;
  }
  .iii{
   float:right;
    padding-right: 20px;
    padding-top: 15px;
  }
}

.qrcode {
  width: 100px;
  height: 100px;

  /*bottom: -10px;*/
}

.footer-fout-size-right {
  font-size: 13px;
  display: block;
  position: relative;
  bottom: -10px;
  right: -13px
}

.footer-fout-size-left {
  font-size: 13px;
  display: block;
  position: relative;
  bottom: -10px;
  right: 7px
}

//.iii {
//
//  display: inline;
//  position: relative;
//  float: right;
//  bottom: 230px;
//  margin-right: 30px;
//}

.tu {
  position: relative;
  right: 150px;

}

.el-menu-item {
  padding: 0 31px;
  font-size: 20px;
  width: 200px !important;
  text-align: center;
  padding: 0 !important;
}

::v-deep.el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: 20px !important;

}

.el-menu-item:hover {
  background-color: #154480 !important;
  color: white !important;
}
::v-deep.el-menu--horizontal>.el-submenu.is-opened>.el-submenu__title{
  background: #154480 !important;
  color: white !important;
}
::v-deep.el-submenu .el-submenu__title:hover {
  background: #154480 !important;
  color: white !important;
}

::v-deep.el-submenu .el-submenu__title {
  width: 200px !important;
  text-align: center !important;

}

::v-deep.shouye {
  font-size: 20px !important;
}

::v-deep.el-menu-item {
  font-size: 18px;
}

.box-card {
  margin-top: 10px;
  width: 100%;
  height: 500px;
  border-top: none !important;
  border-bottom: none !important;
}

.second-card {
  margin: 5px;
}

::v-deep.el-card .el-card__header {
  border-bottom: none !important;

}

::v-deep.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
}

.aaa {
  color: #154480;

}


.aaa :visited {
  color: #E3E6EB;
}

.clearfix {
  color: #6C82A9;
  font: 20px Arial;

  border-bottom: 1px solid #154480;
}


</style>
